module.exports = __webpack_public_path__ + "static/media/exams.1c1cd592.png";